import React from 'react';
import {Card} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import BreadcrumbToolbar from '../components/layouts/BreadcrumbToolbar'
import SystemHubTable from '../components/SystemHubTable';
import SystemHubButtonCreate from '../components/SystemHubButtonCreate';
import {fetchHubs, postHub, updateHub, deleteHub, uploadHub, upgradeHub} from '../actions/hub'
import {UUID_NULL, HUB_STATE_IN_ACTIVE} from '../constants/defaultValues'

class SystemHubs extends React.Component {
  state = {
    hub: {
      Name: '',
      SystemID: UUID_NULL,
      Description: '',
      HubAddress: "",
      State: HUB_STATE_IN_ACTIVE,
      FirmwareVersion: 0,
      NumClients: 0,
      AutoStart: false
    }
  };

  componentWillMount() {
    this.props.dispatch(fetchHubs())
  }

  handleCreate = (values) => {
    const {Name, Description, HubAddress, AutoStart} = values
    const hub = {
      ID: UUID_NULL,
      SystemID: this.props.currentSystem.ID,
      Name: Name,
      Description: Description,
      HubAddress: HubAddress,
      State: HUB_STATE_IN_ACTIVE,
      AutoStart: AutoStart
    }
    this.props.dispatch(postHub(hub))
  }

  handleUpdate = (values) => {
    const {ID, Name, Description, HubAddress, AutoStart} = values
    const hub = {
      ID: ID,
      SystemID: this.props.currentSystem.ID,
      Name: Name,
      Description: Description,
      HubAddress: HubAddress,
      State: HUB_STATE_IN_ACTIVE,
      AutoStart: AutoStart
    }
    this.props.dispatch(updateHub(hub))
  }

  handleDelete = (hub) => {
    this.props.dispatch(deleteHub(hub))
  }

  handleUpload = (newFirmware) => {
    this.props.dispatch(uploadHub(newFirmware))
  }

  handleUpgrade = (upgradeList) => {
    this.props.dispatch(upgradeHub(upgradeList))
  }

  render() {
    const {
      currentUser,
      currentSystem,
      hubs,
      stations,
      groups,
      fetching,
      isMobile
    } = this.props
    const breadcrumbs = [
      {
        Name: "Quản lý hệ thống",
        Link: `/systems`
      }, {
        Name: currentSystem.Name,
        Link: ""
      }
    ]
    return (<div>
      <div className="toolbar">
        <BreadcrumbToolbar items={breadcrumbs}/>
      </div>
      <Card className="card" title="Quản lí hub" bordered={false} extra={<SystemHubButtonCreate hub = {
          this.state.hub
        }
        onCreate = {
          this.handleCreate
        }
        type = "primary" text = "Thêm mới" ghost = {
          true
        } />
}>
        <SystemHubTable hubs={hubs} stations={stations} groups={groups} system={currentSystem} token={currentUser.token} fetching={fetching} onCreate={this.handleCreate} onUpdate={this.handleUpdate} onDelete={this.handleDelete} onUpload={this.handleUpload} onUpgrade={this.handleUpgrade}/>
      </Card>
    </div>);
  }
}

SystemHubs.propTypes = {
  dispatch: PropTypes.func,
  currentSystem: PropTypes.object,
  currentUser: PropTypes.object,
  hubs: PropTypes.array,
  stations: PropTypes.array,
  groups: PropTypes.array,
  fetching: PropTypes.bool
}

const mapStateToProps = function(state) {
  return {
    currentSystem: state.system.currentSystem,
    currentUser: state.user.currentUser,
    hubs: state.hub.hubs,
    stations: state.station.stations,
    groups: state.group.groups,
    fetching: state.hub.fetching
  }
}

export default connect(mapStateToProps)(SystemHubs)



// WEBPACK FOOTER //
// ./src/pages/SystemHubs.js